import request from '@/utils/request'

export function close(deliveredOrderId){
	return request({
		url: `/scm/deliverOrder/close?deliveredOrderId=${deliveredOrderId}`,
		method: 'get'
	})
}

// 到货单列表
export function fetchList (data) {
	return request({
		url: '/scm/deliverOrder/list',
		method: 'POST',
		data
	})
}

//获取到货单商品明细
export function getCheckGoods(data){
	return request({
		url: '/scm/deliverOrder/fastCheck/listGoods',
		method: 'POST',
		data
	})
}

// 到货单详情
export function getOrderDetail (id, data) {
	return request({
		url: `/scm/deliverOrder/${id}`,
		method: 'post',
		data
	})
}

// 验收
export function check (id, data) {
	return request({
		url: `/scm/deliverOrder/check/${id}`,
		method: 'post',
		data
	})
}

//快速验收
export function fastCheck(data){
	return request({
		url: `/scm/deliverOrder/fastCheck`,
		method: 'post',
		data
	})
}

// 添加异常
export function addexp (id, data) {
	return request({
		url: `/scm/deliverOrder/exp/add/${id}`,
		method: 'post',
		data
	})
}

// 更新运费
export function updateShipFee (deliveredOrderId, data) {
	return request({
		url: `/scm/deliverOrder/update/${deliveredOrderId}`,
		method: 'post',
		data
	})
}

// 更新物流单号
export function updateShipNo (deliveredOrderId, data) {
	return request({
		url: `/scm/deliverOrder/update/${deliveredOrderId}`,
		method: 'post',
		data
	})
}

// 修改采购价
export function updateInprice (deliveredOrderId, data) {
	return request({
		url: `/scm/deliverOrder/update/inPrice/${deliveredOrderId}`,
		method: 'post',
		data
	})
}

// 标记缺货
export function updateNum (deliveredOrderId, data) {
	return request({
		url: `/scm/deliverOrder/update/num/${deliveredOrderId}`,
		method: 'post',
		data
	})
}

// 物流信息
export function shippingInfo (alibabaOrderCode) {
	return request({
		url: `/scm/deliverOrder/shippingInfo/${alibabaOrderCode}`,
		method: 'get'
	})
}

// 阿里云oss鉴权
export function getPolicy () {
	return request({
		url: `/aliyun/oss/policy`,
		method: 'get'
	})
}

// 仓库
export function getAllDepotList () {
	return request({
		url: `/wms/depot/listAll`,
		method: 'get'
	})
}

//删除 /oms/order/deleteThDelivery
export function deleteThDelivery (data) {
	return request({
		url: '/oms/order/deleteThDelivery',
		method: 'POST',
		data
	})
}


// 采购人列表
export function getAllAdminList () {
	return request({
		url: '/scm/dict/list',
		method: 'get'
	})
}

// 采购人列表
export function cancelOrder (deliveredOrderId, data) {
	return request({
		url: `/scm/deliverOrder/cancelOrder/${deliveredOrderId}`,
		method: 'POST',
		data
	})
}

// 更新备注
export function updateRemark (data) {
	return request({
		url: '/scm/deliverOrder/addDeliveryOrderRemark',
		method: 'POST',
		data
	})
}

// 到货单导出
export function deliverOrderExport (data) {
	return request({
		url: '/scm/deliverOrder/list/export',
		method: 'POST',
		data,
		responseType: 'blob'
	})
}



// WEBPACK FOOTER //
// ./src/api/sms/arrival-order.js